import React, { createContext, ReactNode, useContext, useEffect } from 'react';
import { IntlProvider as I18nWrapper, useIntl } from 'react-intl';

import { intlService } from '~/i18n/IntlService';

interface CurrencyContextValue {
  currency: string;
}

const CurrencyContext = createContext<CurrencyContextValue | null>(null);

interface Props {
  children: ReactNode;
  currency: string;
  language: string;
  messages: any;
}

const IntlServiceInitializer = () => {
  const intl = useIntl();

  useEffect(() => {
    intlService.init(intl);
    return () => intlService.reset();
  }, [intl]);

  return null;
};

export const I18nProvider = ({
  children,
  //currency,
  language,
  messages,
}: Props) => {
  // TODO: once we have a BE unified currency conversion, we can use the currency prop by adding it to CurrencyContext.Provider

  // NOTE: We pass 'language' to IntlProvider's locale for correct translation message lookups.
  // The formatting locale is retrieved directly from Redux in useFormatDate/useFormatNumber via useSelector.
  // This separates language (translations) from locale (date/number formatting).

  return (
    <I18nWrapper locale={language} defaultLocale="en" messages={messages}>
      <IntlServiceInitializer />
      {children}
    </I18nWrapper>
  );
};

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within CurrencyProvider');
  }
  return context;
};
